/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IVideoCameraHttpService } from './video-camera-http.service.interface';
import { environment } from '../../../../environments/environment';
import { IVideoDeviceInfo } from '../../models/video-device-info.interface';

@Injectable()
export class VideoCameraHttpService implements IVideoCameraHttpService {
  constructor(private readonly _httpClient: HttpClient) {}

  getDeviceInfo(vehicleId: number): Observable<IVideoDeviceInfo> {
    return this._httpClient.get<IVideoDeviceInfo>(
      `${environment.config.endpoints.videoCameraApiEndpoint}/v1/controlunits/vehicleId/${vehicleId}/deviceInfo`
    );
  }
}
